import type {IDefaultGlyphData, IGlyph} from "./CatalogTypes";

export class CatalogGlyphs {
	// eslint-disable-next-line sonarjs/public-static-readonly
	public static defaultGlyphs: IDefaultGlyphData[];
	// eslint-disable-next-line sonarjs/public-static-readonly
	public static glyphs: IGlyph[] = [{innerPart: "", keywords: [], defaultImageID: ""}]; // inner parts of svgs (between <svg> and </svg>)
}
